import React, { useState, useEffect } from 'react'

import { API_URL } from '../Constants';
import Loading from './Loading';

const TVDisplay = ({ id }) => {
  const [data, setData] = useState(null)
  const minutes = 0.5;
  
  useEffect(() => {
    if (!data) {
      getData()
    }

    // Set up the interval to fetch data every * minute(s).
    const intervalId = setInterval(getData, ((1000 * 60) * minutes)); 

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  const getData = () => {
    var formdata = new FormData();
    formdata.append("id", id);

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "tvlots", requestOptions)
      .then(response => response.json())
      .then(result => {
        //console.log(result)
        if (result.code === 200) {
          setData(result.transactions)
        }
      })
      .catch(error => console.log('error', error));
  }

  const statusColor = (status) => {
    if (status == 1) {
      return 'bg-cyan-500';
    }

    if (status == 0) {
      return 'bg-accent';
    }

    if (status == 2) {
      return 'bg-primary text-white';
    }

    if (status == 3) {
      return 'bg-red-500';
    }

    if (status == 4) {
      return 'bg-green-500';
    }
  }

  const statusDisplay = (status) => {
    if (status == 1) {
      return (
        <div className='font-bold'>Open</div>
      )
    }

    if (status == 0) {
      return (
        <div className='font-bold'>Closed</div>
      )
    }

    if (status == 2) {
      return (
        <div className='leading-3 font-bold'>Requested</div>
      )
    }

    if (status == 3) {
      return (
        <div className='leading-3 font-bold'>Make Ready</div>
      )
    }

    if (status == 4) {
      return (
        <div className='leading-3 font-bold'>Car Ready</div>
      )
    }
  }

  return (
    <div className=''>
      {data ? (
        <div>
          <div className='flex justify-between items-center px-10 w-full fixed bg-primary text-white'>
            <div className='text-left uppercase font-bold p-2 w-1/6'>Tag</div>
            <div className='text-center uppercase font-bold p-2 w-1/6'>Stall#</div>
            <div className='text-center uppercase font-bold p-2 w-1/3'>Name</div>
            <div className='text-center uppercase font-bold p-2 w-1/3'>Vehicle</div>
            <div className='text-right uppercase font-bold p-2 w-1/6'>Status</div>
          </div>

          <div className='min-h-screen flex-col flex items-center justify-start bg-secondary py-4 px-3 sm:px-6 lg:px-8'>
            <ul className='w-full pt-10'>
              {data.map((transaction, index) => (
                <li key={index} className={statusColor(transaction.status) + ' flex justify-between items-center w-full mb-2 rounded text-2xl font-bold'}>
                  <div className='text-left p-2 lg:p-4 w-1/6 '>{transaction.key_tag}</div>
                  <div className='text-center p-2 lg:p-4 w-1/6'>{transaction.stall_number}</div>
                  <div className='text-center p-2 lg:p-4 w-1/3'>{transaction.customer_name}</div>
                  <div className='text-center p-2 lg:p-4 w-1/3'>{transaction.vehicle_make } ({transaction.vehicle_color})</div>
                  <div className='text-right p-2 lg:p-4 w-1/6'>{statusDisplay(transaction.status)}</div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ) : (
        <Loading name="Data" />
      )}
    </div>    
  ) 
}

export default TVDisplay